export default {
  product: {
    name: 'Køb gavekort',
  },
  description: {
    items: {
      delivery: 'Sendes med det samme på e-mail som PDF',
      usage: {
        online: 'Kan kun indløses online',
        online_and_store: 'Kan indløses online og i restauranten',
      },
      value: 'Fleksible beløb fra {{from}} til {{to}}',
    },
  },
};
